import Link from "next/link";

interface TimelineStep {
  phase: string;
  duration: string;
  title: string;
  description: string;
}

interface TimelineInlineCta {
  eyebrow?: string;
  description: string;
  link: {
    label: string;
    href: string;
  };
  afterStepIndex?: number;
}

interface TimelineStepsProps {
  steps: TimelineStep[];
  inlineCta?: TimelineInlineCta;
  className?: string;
}

export default function TimelineSteps({ steps, inlineCta, className }: TimelineStepsProps) {
  const ctaIndex =
    inlineCta && Number.isInteger(inlineCta.afterStepIndex)
      ? Math.min(Math.max(inlineCta.afterStepIndex as number, 0), steps.length - 1)
      : 0;

  const isCalendly = inlineCta?.link.href.includes("calendly.com");

  return (
    <div className={className ? `timeline ${className}` : "timeline"}>
      {steps.map((step, index) => (
        <div key={`${step.phase}-${step.title}`}>
          <div className="tl-step">
            <div className="tl-meta">
              <span className="tl-num">{step.phase}</span>
              <span className="tl-dur">{step.duration}</span>
            </div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
          {inlineCta && index === ctaIndex ? (
            <div className="tl-note">
              {inlineCta.eyebrow ? (
                <span className="tl-note-eyebrow">{inlineCta.eyebrow}</span>
              ) : null}
              <p
                className="tl-note-text"
                dangerouslySetInnerHTML={{ __html: inlineCta.description }}
              />
              <Link
                href={inlineCta.link.href}
                className="btn btn-ghost btn-sm tl-note-btn"
                {...(isCalendly
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {})}
              >
                {inlineCta.link.label}
              </Link>
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
